import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WsChatService } from '../../lds-websocket-module/ws-chat/ws-chat.service';
import { WsPacketService } from '../../lds-websocket-module/ws-packet/ws-packet.service';
import { LdsPrebuiltWschatService } from '../../lds-websocket-module/pre-built/lds-prebuilt-wschat.service';
import { WebSocketPacket } from '../../interfaces/all';
import { LdsUserService } from '../../services/lds-user.service';
import { DemoAccountService } from '../../demo-account.service';

@Component({
    selector: 'lds-feature-list',
    templateUrl: './feature-list.component.html',
    styleUrls: ['./feature-list.component.css'],
    standalone: false
})
export class FeatureListComponent implements OnInit, OnChanges {
	@Input() data: any;
	@Input() features: any;
	@Input() deviceType: any;
  @Input() productCode: string;
  @Input() timespan: string;
	toDisplay: any[];
	public unitLookUp = {
		'average daily': 'Wh',
		'energy': 'Wh',
		'power': 'W',
		'temperature': String.fromCharCode(176) + 'C',
		'valveLevel': '%',
		'switch': 'Status',
		'dimLevel': '%',
		'targetTemperature': String.fromCharCode(176) + 'C'
	};

	statusColorLoopup(status) {
		switch (status) {
			case 'init':
			case 'unknow':
				return 'orange';
			case 'error':
				return 'red';
			default:
				return 'darkgreen';
		}
	}

	constructor(private wsChatService: WsChatService, private wsPacketService: WsPacketService, private ws: LdsPrebuiltWschatService, private user: LdsUserService, private demo: DemoAccountService) { }

	ngOnInit() {
      if (!this.timespan) this.timespan = 'weekly';
  
	}

	ngOnChanges(changes: SimpleChanges) {

		if (changes.features && changes.features.previousValue) {
			for (let index = 0; index < changes.features.previousValue.length; index++) {
				const element = changes.features.previousValue[index].featureId;
				this.wsChatService.unsubscribeNotification(element);
			}
		}
		if (!changes.data) {
			return;
		}

    if (changes.timespan) {
      this.timespan = changes.timespan.currentValue;
    }
		this.toDisplay = [];
		let wsPackets: WebSocketPacket[] = [], average: number | string = 0;
    const displayHelperObj = {
      energy: ['L92', 'L92MK2', 'AHC', 'BRD91', 'L92R', 'LW920', 'LW934'],
      power: ['L92', 'L92MK2', 'AHC', 'BRD91', 'L92R', 'LW920', 'LW934'],
      movement: [],
      switch: [],
      dimLevel: [],
      temperature: ['LW931', 'L70'],
      targetTemperature: ['LW931', 'L70'],
      buttonPress: [],
      windowPosition: ['HR92'],
      valveLevel: ['LW921E', 'LW921', 'AHM', 'AFSV', 'AFS', 'T87RF', 'EVO', 'DT92E'],
    };
		switch (this.deviceType) {
			case 'energy':
				for (let i = 0; i < this.features.length; i++) {
          if (this.features[i].attributes.type === 'power') {
            this.toDisplay.splice(1, 0, {
              featureId: this.features[i].featureId,
              name: 'Current Power',
              value: 'loading',
              unit: "W"
            });
          } else {
            this.toDisplay.push({
              featureId: this.features[i].featureId,
              name: this.features[i].attributes.type,
              value: 'loading'
            });
          }
          if (!this.demo.isDemo()){
            wsPackets.push(this.wsPacketService.getPacket('feature', 'read', {
              featureId: this.features[i].featureId,
            }));
          }
				}

				for (let i = 0; i < changes.data.currentValue.length; i++) {
					average += changes.data.currentValue[i].value;
				}

        const averageMultiplier = this.timespan === 'weekly' ? 7 : 30;
				average = (average / 1000 / averageMultiplier).toFixed(2)

				this.toDisplay.push({
					name: `Average energy`,
					value: average,
          unit: 'Wh',
				});
        if (this.demo.isDemo()) {
          for (let i = 0; i < this.toDisplay.length; i++) {
            this.resToDisplay(null, this.toDisplay[i]);
          }
        }
        else {
          this.wsChatService.sendMsgAsyc({
            data: wsPackets, next: (res: WebSocketPacket[]) => {
              for (let i = 0; i < res.length; i++) {
                if (this.toDisplay[i].featureId) {
                  const type = res[i].items[0].payload.type;
                  let  toDisplayItem;
                  if (type === 'power') {
                    toDisplayItem = this.toDisplay.find(item => item.name === 'Current Power');
                    toDisplayItem.unit = this.unitLookUp[type];
                  } else {
                    toDisplayItem = this.toDisplay.find(item => item.name === type);
                    toDisplayItem.unit = this.unitLookUp[type];
                  }
                  this.resToDisplay(res[i], toDisplayItem);
                }
              }
            }
          });
        }
				break;
			default:
        if (this.demo.isDemo()) {
          for (let i = 0; i < this.toDisplay.length; i++) {
            this.resToDisplay(null, this.toDisplay[i]);
          }
        } else {
          let promises = [];
          for (let i = 0; i < this.features.length; i++) {

            if (!displayHelperObj[this.features[i].attributes.type] || !displayHelperObj[this.features[i].attributes.type].includes(this.productCode)) {
              if (this.deviceType === 'switch') {
                if (this.features[i].attributes.type !== 'switch' && this.features[i].attributes.type !== 'dimLevel') {
                  continue
                }
              }

              this.toDisplay.push({
                featureId: this.features[i].featureId,
                name: this.features[i].attributes.type,
                unit: this.unitLookUp[this.features[i].attributes.type]
              });
              promises.push(this.ws.readFeature(this.features[i].featureId));
            }
          }

          Promise.all(promises)
            .then((res: WebSocketPacket[]) => {
              for (let i = 0; i < res.length; i++) {
                if (this.toDisplay[i].featureId) {
                  this.resToDisplay(res[i], this.toDisplay[i]);
                }
              }

          });
        }
		}
		for (let index = 0; index < this.toDisplay.length; index++) {
			const element = this.toDisplay[index];
			this.getNotification(element.featureId, element.name, index);
    }
    // TODO: Sort array order here - mostly for devices with dimLevel
	}

	private resToDisplay(res, toDisplay) {
    const demoGetRandom = (array) => {
      const rand = Math.floor(Math.random() * array.length);
      return array[rand];
    }

		try {
			if (toDisplay.name === 'energy') {

        let featureSet;
        if(this.user.isEnergyMonitor(this)){
          // featureSet = this.user.energyMonitors[this.features[0].deviceId];
          featureSet = this.user.energyMonitors[this.features[0].groups[0]];
        }else{
          featureSet = this.user._energyFeatureSets[this.features[0].groups[0]];
        }
       
        let usageToShow = 0;

        for(let i in this.data){
          const dataPoint = this.data[i];
          usageToShow+=dataPoint.value;
        }
    
        usageToShow = usageToShow/1000;

        const settings = this.user._settings;
        const energySettings = settings.settings.find(setting => setting.label === 'Energy');
        const energySettingItem = energySettings.items.find(energySetting => energySetting.label === 'Unit Rate');

        const unitPrice = energySettingItem ? energySettingItem.value : 0.12;

				toDisplay.value = usageToShow;

        if (!this.toDisplay.some(item => item.name === 'Carbon Footprint')) {
          this.toDisplay.push({
            name: 'Carbon Footprint',
            unit: 'kg of CO²',
            value: (usageToShow * 0.309).toFixed(2),
          });
        } else {
          this.toDisplay.forEach(item => {
              if (item.name === 'Carbon Footprint') {
                item.value = (usageToShow * 0.309).toFixed(2);
              }
          })
        }
        if (!this.toDisplay.some(item => item.name === 'Device Cost')) {
          this.toDisplay.push({
            name: 'Device Cost',
            unit: '£',
            value: (usageToShow * unitPrice).toFixed(2),
          });
        } else {
          this.toDisplay.forEach(item => {
              if (item.name === 'Device Cost') {
                item.value = (usageToShow * unitPrice).toFixed(2);
              }
          })
        }
			} else if (toDisplay.name === 'switch') {
        if (this.demo.isDemo()) {
          toDisplay.value = 'on'
        } else {
          toDisplay.value = res.items[0].payload.value ? 'On' : 'Off';
        }
			} else if (toDisplay.name === 'movement') {
        if (this.demo.isDemo()) {
          toDisplay.value = 'No Motion';
        } else {
				  toDisplay.value = res.items[0].payload.value ? 'Motion' : 'No Motion';
        }
			} else if (toDisplay.name === 'temperature' || toDisplay.name === 'targetTemperature') {
        if (this.demo.isDemo()) {
          toDisplay.value = 18
        } else {
          toDisplay.value = (res.items[0].payload.value / 10).toFixed(1);
        }
      } else {
        if (this.demo.isDemo()) {
          if (toDisplay.name === 'Current Power') {
            toDisplay.value = 3.7;
          }
          if (toDisplay.name === 'dimLevel') {
            toDisplay.value = 100;
          }
          if (toDisplay.name === 'valveLevel') {
            toDisplay.value = 100;
          }
        } else {
          toDisplay.value = res.items[0].payload.value;
        }
			}
      if (!this.demo.isDemo()) {
        toDisplay.status = res.items[0].payload.status;
      }
		} catch (err) {
			console.log('error ', err, res, toDisplay);
		}
	}

	private getNotification(featureId, type, index) {
		this.wsChatService.subscribeNotification(featureId, (notification) => {
			this.resToDisplay(notification, this.toDisplay[index]);
		});
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
}
